export default __webpack_public_path__ + "static/media/SpecialDiscs.06da7f9a.png";